import styled from 'styled-components'

function Footer() {

  const Container = styled.footer`
    margin-top: 96px;
    background: #16242b;
    color: rgba(247, 245, 240, 0.7);
    padding: 48px 32px 24px;
    border-top: 1px solid rgba(201, 184, 151, 0.18);
  `;

  const Inner = styled.div`
    max-width: 1320px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 32px;
    }
  `;

  const About = styled.div`
    h5 {
      font-family: 'Rubik', sans-serif;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.18em;
      color: #c9b897;
      margin: 0 0 14px 0;
      font-weight: 500;
    }
    p {
      font-size: 13px;
      line-height: 1.55;
      color: rgba(247, 245, 240, 0.7);
      margin: 0 0 8px 0;
      font-family: 'Rubik', sans-serif;
      font-weight: 300;
    }
  `;

  const LinkCol = styled.div`
    h5 {
      font-family: 'Rubik', sans-serif;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.18em;
      color: #c9b897;
      margin: 0 0 14px 0;
      font-weight: 500;
    }
    a {
      display: block;
      font-family: 'Rubik', sans-serif;
      font-size: 14px;
      color: rgba(247, 245, 240, 0.7);
      text-decoration: none;
      padding: 4px 0;
      transition: color 0.2s;

      &:hover {
        color: #c9b897;
      }
    }
  `;

  const Colophon = styled.div`
    max-width: 1320px;
    margin: 32px auto 0;
    padding-top: 20px;
    border-top: 1px solid rgba(201, 184, 151, 0.12);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Rubik', sans-serif;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: rgba(247, 245, 240, 0.4);

    @media (max-width: 600px) {
      flex-direction: column;
      gap: 8px;
      text-align: center;
    }
  `;

  return (
    <Container>
      <Inner>
        <About>
          <h5>About the Archive</h5>
          <p>The 8th Air Force Operations Research Database is a project of the Eighth Air Force Historical Society, dedicated to the preservation and accessibility of WWII operational records.</p>
        </About>
        <LinkCol>
          <h5>The Society</h5>
          <a href="https://www.8thafhs.org" target="_blank" rel="noopener noreferrer">Main Website</a>
          <a href="https://portal.8thafhs.org" target="_blank" rel="noopener noreferrer">Member Portal</a>
          <a href="https://www.8thafhs.org/membership" target="_blank" rel="noopener noreferrer">Membership</a>
          <a href="https://www.8thafhs.org/donate" target="_blank" rel="noopener noreferrer">Donate</a>
        </LinkCol>
        <LinkCol>
          <h5>Research</h5>
          <a href="/missions">Browse Missions</a>
          <a href="/groups">Browse Groups</a>
          <a href="/honor-roll">Honor Roll</a>
          <a href="/sources">Sources</a>
        </LinkCol>
      </Inner>
      <Colophon>
        <span>© Eighth Air Force Historical Society</span>
        <span>Operations Research Database</span>
      </Colophon>
    </Container>
  );
}

export default Footer;
